interface SEOJsonLDProps {
  data: Record<string, unknown>;
}

export default function SEOJsonLD({ data }: SEOJsonLDProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}